import React, {useEffect, useState} from 'react';
import {Container, Row, Col} from 'reactstrap';
import ReactSelect from '../../../Shared/ReactSelect/ReactSelect';
import BasicText from '../DebtPaymentComponents/basicText';
import CompanyTypeSelect from '../DebtPaymentComponents/companyTypeSelect';
import {stepEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import DeniedMessage from '../DebtPaymentComponents/deniedMessage';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {CSSTransition} from 'react-transition-group';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';

import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const DebtPaymentCompanySelect = (props) => {
  const {orgDetailList, setSelectedForUpdate, redirectToLobby} = props;
  const [ifMultiple, setMultiple] = useState(false);
  const [ifForbidden, setForbidden] = useState(false);
  const [selectedOrgId, setSelectedOrgId] = useState(null);
  const [selectedIdNumber, setSelectedIdNumber] = useState(null);
  const [selectObj, setSelectObj] = useState(null);
  const [skipStep, setSkipStep] = useState(false);
  const [mount, setMount] = useState(false);
  const [localOrgDetailList, setLocalOrgDetailList] = useState(orgDetailList);

  const radioBtns = [
    {id: 'cellcom', label: `${window.Config.brand_Name_HE}`, value: 'cellcom'},
    {id: 'netvision', label: "נטוויז'ן", value: 'netvision'},
  ];

  const selectBoxObj = [];

  useEffect(() => {
    if (localOrgDetailList) {
      localOrgDetailList.map((org) => {
        let item = {
          key: {org: org.orgId, id: org.idNumber},
          value: org.orgName + ' ' + org.idNumber,
        };
        selectBoxObj.push(item);
      });
      setSelectObj(selectBoxObj);
    }
  }, [localOrgDetailList]);

  const messageText = 'כדי להמשיך, יש צורך בהרשאה מתאימה.<br/> צוות השירות העסקי ישמח לעזור';
  const subMessageText = 'חייגו 234* לעדכון הרשאה';

  useExtendedEffect(
    (runSideEffects) => {
      if (props.currentStep === stepEnum.COMPANYSELECT && orgDetailList && orgDetailList.length > 0) {
        if (runSideEffects()) {
          setLocalOrgDetailList(orgDetailList);
          autoSelect();
          gaEvent(gaParams.DEBT_PAYMENT_SHOW_COMPANYLIST.category, gaParams.DEBT_PAYMENT_SHOW_COMPANYLIST.eventType, orgDetailList.length);
        }
      } else {
        setMount(false);
      }
    },
    [selectObj, props.currentStep],
  );

  // useEffect(() => {
  //   autoSelect();
  // }, [selectBoxObj]);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        props.setSelectedOrgId(selectedOrgId);
      }
    },
    [selectedIdNumber, selectedOrgId],
  );

  const autoSelect = () => {
    setSkipStep(false);
    if (selectObj && selectObj.length > 0) {
      if (props.selectedFromPortal || props.selectedOrgId) {
        let id = props.selectedFromPortal || props.selectedOrgId;
        const selectedOrg = selectObj.find((org) => org.key.id == id || org.key.org == id);
        if (selectedOrg) {
          validateSelectedOrg(selectedOrg.key);
        }
      } else if (selectObj.length === 1) {
        validateSelectedOrg(selectObj[0].key);
      } else {
        setMount(true);
      }
    }
  };

  const validateSelectedOrg = (selectedOrgId) => {
    setMultiple(false);
    setForbidden(false);

    if (selectedOrgId && selectedOrgId != undefined) {
      const selectedOrg = localOrgDetailList.find((org) => org.orgId == selectedOrgId.org);

      setSelectedOrgId(selectedOrgId.org);
      setSelectedIdNumber(selectedOrgId.id);

      let roles = selectedOrg.bussinesContactRole;

      let NVRoles = checkNVRoles(roles);

      if (roles.isActionAllowedCellcom === true && NVRoles === true) {
        setMultiple(true);
        setMount(true);
      } else {
        if (roles.isActionAllowedCellcom === true && NVRoles === false) {
          props.setSelectedProvider('cellcom');
          if (props.skipStep) {
            setSkipStep(true);
          }
        } else if (roles.isActionAllowedCellcom === false && NVRoles === true) {
          props.setSelectedProvider('netvision');
          if (props.skipStep) {
            setSkipStep(true);
          }
        }
        setMount(!props.selectedFromPortal || props.selectedFromPortal === '');
        if (roles.isActionAllowedCellcom === false && NVRoles === false) {
          setForbidden(true);
          setMount(true);
        }
      }
    }
  };

  useEffect(() => {
    if (!ifMultiple && !ifForbidden && selectedIdNumber && props.skipStep && (props.selectedProvider === 'netvision' || selectedOrgId)) {
      setSelectedForUpdate(selectedIdNumber, selectedOrgId, props.skipStep);
    }
  }, [props.skipStepm, props.selectedProvider, selectedIdNumber, selectedOrgId]);

  const checkNVRoles = (roles) => {
    if (roles.hasPayingEntity === true) {
      return roles.isActionAllowedNv && roles.isActionAllowedPayingNv;
    } else {
      return roles.isActionAllowedNv;
    }
  };

  const onRadioBtnChange = (e) => {
    let value = e.currentTarget.value;
    props.setSelectedProvider(value);
  };

  return (
    <CSSTransition key={1} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='על איזה ח.פ. מדובר?' classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Container className={`debtpayment-select-box ${ifForbidden ? 'with-error' : ''}`}>
          <Row className='justify-content-md-center'>
            {selectObj && selectObj.length > 0 && (
              <Col lg='4' className='select-box'>
                <ReactSelect
                  inputProps={{readOnly: true}}
                  isSearchable={false}
                  className={`${localOrgDetailList.length === 1 ? 'disabled' : ''}`}
                  getOptionLabel={(option) => option.value}
                  getOptionValue={(option) => option.key}
                  // defaultValue={{id: -1, name: '.בחר ח.פ'}} //optional
                  placeholder='בחירת ח.פ.'
                  value={selectObj.filter((option) => option.key.org == selectedOrgId)}
                  name='selected'
                  options={selectObj}
                  onChange={(e) => validateSelectedOrg(e.key)}
                />
              </Col>
            )}
          </Row>
        </Container>

        {ifMultiple && !ifForbidden && (
          <CompanyTypeSelect
            text='בחירת סוג חשבון'
            radioBtns={radioBtns}
            selectedProvider={props.selectedProvider}
            onRadioBtnChange={onRadioBtnChange}
          />
        )}

        {ifForbidden && <DeniedMessage messageText={messageText} subMessageText={subMessageText} isMobile={props.isMobile} />}

        <Row className={`justify-content-md-center footer-btn ${props.isMobile ? 'footer-btn-bottom' : ''}`}>
          {props.isMobile && <Col xs={6}></Col>}
          <Col md='auto' className={`${props.selectedProvider == null && !ifForbidden ? 'disabled-btn' : ''}`}>
            {ifForbidden ? (
              <BtnSubmit isBusiness text='הבנתי' onclick={() => redirectToLobby()} />
            ) : (
              <BtnSubmit isBusiness text='אפשר להתקדם' onclick={() => setSelectedForUpdate(selectedIdNumber, selectedOrgId, skipStep)} />
            )}
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default DebtPaymentCompanySelect;
